






































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import TableActions from "@/components/form/TableActions.vue";
import { TestQuestion as ITestQuestion } from "@/api/models";
import TestQuestionManualForm from "@/components/tests/TestQuestionManualForm.vue";
import { TestQuestionCreate as ITestQuestionCreate } from "@/api/models/test-question-create";
import { TestQuestionEdit as ITestQuestionEdit } from "@/api/models/test-question-edit";
import api from "@/getinfo-api";

@Component({
  components: {
    TestQuestionManualForm,
    TableActions,
    CustomTableCol,
    CustomTableItem
  }
})
export default class TestQuestionsListItem extends Vue {
  @Prop() question!: ITestQuestion | ITestQuestionCreate;
  @Prop() questionIndex!: number;
  @Prop() flag!: boolean;
  @Prop() questionLoading!: boolean;
  questionItem!: ITestQuestion | ITestQuestionCreate | undefined;
  isAnswersShowed: boolean = false;
  isQuestionEdit: boolean = false;
  uniqId: string =
    "id" +
    Math.random()
      .toString(16)
      .slice(2);

  get isAnswerHasComment() {
    return this.question?.answers?.some(el => el.comment);
  }

  confirmEdit(question: any) {
    this.questionItem = question;
    this.isQuestionEdit = false;
    if (question?.testId) {
      const params: ITestQuestionEdit = {
        answers: question.answers,
        body: question.body
      };
      api.TestApi.editQuestion(question?.testId, question.id, params);
    }
  }

  cancelEdit() {
    this.isQuestionEdit = false;
  }

  removeQuestion() {
    this.$emit("removeQuestion", this.questionIndex);
  }

  created() {
    this.questionItem = this.question ? this.question : undefined;
  }

  editQuestion() {
    this.$emit("isStartToEditQuestion");
    setTimeout(() => {
      this.isQuestionEdit = true;
    }, 300);
  }

  @Watch("flag")
  checkIndex() {
    this.isAnswersShowed = false;
    this.isQuestionEdit = false;
  }
}
